import svgToTinyDataUri from '../svg-to-mini-data-uri';

const footerEnvelopeIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="2" y="3" width="12" height="10" rx="1.5" stroke="#2B2A35" stroke-width="1.5" />
  <path d="M3 4l5 4 5-4" stroke="#2B2A35" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

export const footerEnvelopeIcon = svgToTinyDataUri(footerEnvelopeIconSvg);
